import { abuseSlice } from "./Slices/AbuseSlice";
import { AuthSlice } from "./Slices/AuthSlice";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import {
  combineReducers,
  configureStore,
  ThunkAction,
  Action,
} from "@reduxjs/toolkit";
import { LayoutSlice } from "./Slices/LayoutSlice";
import { liveStreamSlice } from "./Slices/LiveStreamSlice";
import { folderSlice } from "./Slices/FolderSlice";
import { destinationsSlice } from "./Slices/DestinationsSlice";
import { mediaSlice } from "./Slices/MediaSlice";
import { ShowsSlice } from "./Slices/ShowsSlice";
import { AdminSlice } from "./Slices/AdminSlice";
import billingReducer from "./Slices/BillingSlice";
import { entitlementSlice } from "./Slices/EntitlementSlice";
import { operationsSlice } from "./Slices/OperationsSlice";

const rootReducer = combineReducers({
  auth: AuthSlice.reducer,
  admin: AdminSlice.reducer,
  abuse: abuseSlice.reducer,
  layout: LayoutSlice.reducer,
  liveStream: liveStreamSlice.reducer,
  folder: folderSlice.reducer,
  destinations: destinationsSlice.reducer,
  media: mediaSlice.reducer,
  shows: ShowsSlice.reducer,
  billing: billingReducer,
  entitlement: entitlementSlice.reducer,
  operations: operationsSlice.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  any,
  Action<string>
>;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
